import type { GateMemberStatus } from '../../hooks/gate/useGateScreenData'
import AppIcon from '../icons/AppIcon'
import Avatar from '../primitives/Avatar'
import styles from './GateScreen.module.css'

interface GateCompletionProps {
  members: GateMemberStatus[]
  submittedCount: number
  teamSize: number
}

export default function GateCompletion({ members, submittedCount, teamSize }: GateCompletionProps) {
  const percent = teamSize > 0 ? (submittedCount / teamSize) * 100 : 0

  return (
    <>
      <div className={styles.section}>
        <span className={styles.eyebrow}>Team completion</span>
        <span className={styles.count}>
          {submittedCount} / {teamSize} done
        </span>
      </div>
      <div className={styles.compBar}>
        <span className={styles.compFill} style={{ width: `${percent}%` }} />
      </div>
      <div className={styles.cavs}>
        {members.map((member) => (
          <span
            key={member.userId}
            className={[styles.cav, member.submitted ? styles.cavDone : styles.cavPending]
              .filter(Boolean)
              .join(' ')}
            title={member.firstName}
          >
            <Avatar initials={member.initials} photoUrl={member.photoUrl} size="sm" />
            {member.submitted && (
              <span className={styles.cavCheck}>
                <AppIcon icon="mdi:check" size={9} />
              </span>
            )}
          </span>
        ))}
      </div>
    </>
  )
}
